import { createInstance } from "i18next";
import type { i18n as I18nInstance } from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./locales/fr/common.json";
import en from "./locales/en/common.json";

/**
 * i18next confinement (ADR-0013): this package is the ONLY module allowed to import i18next —
 * apps depend on I18nProvider/useTranslation (dependency-cruiser enforces the boundary, same
 * pattern as posthog-js in @repo/analytics).
 */
export const SUPPORTED_LOCALES = ["fr", "en"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

/** FR default, EN when the browser prefers it — a two-line detector, no plugin (ADR-0013). */
export function detectLocale(language?: string): SupportedLocale {
  const candidate = language ?? (typeof navigator !== "undefined" ? navigator.language : undefined);
  return candidate?.toLowerCase().startsWith("en") ? "en" : "fr";
}

export const i18n: I18nInstance = createInstance();

void i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, en: { translation: en } },
  lng: detectLocale(),
  fallbackLng: "fr", // a missed translation shows French, never a raw key (ADR-0013)
  // Catalogs are FLAT key/value maps — "a.b.c" is one key, not nesting.
  keySeparator: false,
  nsSeparator: false,
  interpolation: { escapeValue: false }, // React already escapes
});
